import React, { createContext, useContext, useEffect } from 'react';
import useStore from 'hooks/useStore';

export const cartPageContext = createContext();
const { Provider } = cartPageContext;

export function useCartPage() {
  const ctx = useContext(cartPageContext);
  return ctx;
}

export default function CartPageProvider({ children }) {
  const { state, dispatch } = useStore({});

  useEffect(() => {
    const initialState = localStorage.getItem('cartState')
      ? JSON.parse(localStorage.getItem('cartState'))
      : {};
    dispatch({
      type: 'reset',
      payload: {
        ...initialState,
        ready: true
      }
    });
  }, []);

  useEffect(() => {
    if (state.ready) {
      // localStorage.setItem('cartState', JSON.stringify(state));
    }
  }, [state]);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
}
